import type { Font } from "@/react/story/types";
import { createContext, type ReactNode, useContext } from "react";

type Context = {
    all: Font[];
    count: number;
    set: (fonts: Font[]) => Promise<void>;
    save: (font: Font) => Promise<void>;
    remove: (font: Font) => Promise<void>;
    getStyleNode: () => ReactNode;
}

export const FontsContext = createContext<Context>({} as Context);

export const useFonts = () => useContext(FontsContext);
